import React from "react";
import { Element } from "react-scroll";

import PageWrapper from "../components/PageWrapper";
import Hero from "../sections/landing1/Hero";
import Works from "../sections/landing1/Works";
import About from "../sections/others/About.js";
import Contact from "../sections/landing1/Contact";
import { default as ContactMe } from "../sections/others/Contact.js";

const IndexPage = () => {
  return (
    <>
      <PageWrapper>
        <Hero />
        <Element name="works">
          <Works />
        </Element>

        <Element name="about">
          <About />
        </Element>

        <Element className="mt-5" name="myStory">
          <Contact />
        </Element>

        <Element className="mt-0 pt-0" name="contact">
          <ContactMe />
        </Element>
      </PageWrapper>
    </>
  );
};
export default IndexPage;
